if (!customElements.get('product-info-tabs')) {
  class ProductInfoTabs extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('[data-tab-button]'));
      this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
      this.panelsWrap = this.querySelector('.product-info-tabs__panels');
      this.transitionMs = 250;
      this.isTransitioning = false;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!this.buttons.length || !this.panels.length) return;

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          this.activate(button.dataset.tabId);
        });
      });

      const initial =
        this.buttons.find((button) => button.getAttribute('aria-selected') === 'true') || this.buttons[0];
      this.activate(initial.dataset.tabId, false);
    }

    activate(tabId, animate = true) {
      if (!tabId) return;

      const nextPanel = this.panels.find((panel) => panel.dataset.tabId === tabId);
      const currentPanel = this.panels.find((panel) => panel.classList.contains('is-active'));

      if (!nextPanel || currentPanel === nextPanel) return;
      if (this.isTransitioning) return;

      this.updateButtons(tabId);

      if (!animate || !currentPanel || this.prefersReducedMotion) {
        this.swapPanels(currentPanel, nextPanel);
        return;
      }

      this.isTransitioning = true;

      if (this.panelsWrap) {
        this.panelsWrap.style.minHeight = `${currentPanel.offsetHeight}px`;
      }

      currentPanel.classList.remove('is-active');
      currentPanel.classList.add('is-leaving');

      window.setTimeout(() => {
        currentPanel.hidden = true;
        currentPanel.classList.remove('is-leaving');

        nextPanel.hidden = false;
        nextPanel.classList.add('is-active', 'is-entering');

        if (this.panelsWrap) {
          this.panelsWrap.style.minHeight = `${nextPanel.offsetHeight}px`;
        }

        requestAnimationFrame(() => {
          nextPanel.classList.remove('is-entering');
        });

        window.setTimeout(() => {
          if (this.panelsWrap) {
            this.panelsWrap.style.minHeight = '';
          }
          this.isTransitioning = false;
        }, this.transitionMs);
      }, this.transitionMs);
    }

    updateButtons(tabId) {
      this.buttons.forEach((button) => {
        const isActive = button.dataset.tabId === tabId;
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.tabIndex = isActive ? 0 : -1;
      });
    }

    swapPanels(currentPanel, nextPanel) {
      if (currentPanel) {
        currentPanel.classList.remove('is-active', 'is-leaving', 'is-entering');
        currentPanel.hidden = true;
      }

      nextPanel.hidden = false;
      nextPanel.classList.remove('is-leaving', 'is-entering');
      nextPanel.classList.add('is-active');
    }
  }

  customElements.define('product-info-tabs', ProductInfoTabs);
}
